<div class="generic-purchase-request-dialog-container w-100 flex-col">
  <div class="header w-100">
    <div class="header-actions w-100 flex-row justify-end">
      <mat-icon (click)="onCancel.emit()">close</mat-icon>
    </div>
    <div class="header-content flex-row items-center space-between">
      <div class="flex-col gap-4">
        @if (id()) {
          <mat-basic-chip class="custom-cost-center-chip">#{{ id() }}</mat-basic-chip>
        }
        <span class="title">{{ title() }}</span>
        <span class="normal-text">{{ description() }}</span>
      </div>

      <div class="flex-col gap-8">
        <ng-content select="[headerAction]"></ng-content>
        <ng-content select="[headerStatus]"></ng-content>
        <ng-content select="[headerRequestedAt]"></ng-content>
      </div>
    </div>
  </div>

  <div class="content-area flex-col flex-1">
    <ng-content select="[notification]"></ng-content>

    <div class="table-section flex-col flex-1">
      <ng-content select="[tableContent]"></ng-content>
    </div>
  </div>

  @if (showDeclineButton() || showApproveButton()) {
    <div class="button-container">
      <div class="flex-row justify-end gap-8">
        @if (showDeclineButton()) {
          <button
            (click)="onDecline.emit()"
            mat-button
            color="warn"
            [disabled]="disableDeclineButton()">
            {{ declineButtonText() }}
          </button>
        }
        @if (showApproveButton()) {
          <button
            (click)="onApprove.emit()"
            mat-flat-button
            color="primary"
            [disabled]="disableApproveButton()">
            {{ approveButtonText() }}
          </button>
        }
      </div>
    </div>
  }
</div>
